import { INote } from "./note.types"
import { Dayjs } from "dayjs"

export class Note implements INote {
  id: number
  createdDate: Dayjs
  summary: string
  content: string
  user: string

  constructor(
    id: number,
    createdDate: Dayjs,
    summary: string,
    content: string,
    user: string,
  ) {
    this.id = id
    this.createdDate = createdDate
    this.summary = summary
    this.content = content
    this.user = user
  }

  get isPhotoUpdateNote() {
    return this.summary.includes("PHOTO RECEIVED")
  }
}
